import { Select } from '@mantine/core';
import { TAgent, useAgents } from '@/models/agents';

export default function AgentSelector({
  agent,
  onSelected,
}: {
  agent?: TAgent;
  onSelected: (agent: TAgent) => void;
}) {
  const { data: agents } = useAgents();

  if (!agents) return <>...</>;

  return (
    <Select
      label="Agent"
      searchable={agents.length > 0}
      size="xs"
      defaultValue={agent?.name}
      onChange={(id) => {
        const agent = agents.find((a: TAgent) => a.id === parseInt(id!))!;
        onSelected(agent);
      }}
      data={agents.map((a: TAgent) => ({ value: String(a.id), label: a.name }))}
      allowDeselect={false}
    />
  );
}
